import { SeatGroupDisplayMode } from 'libs/core/src/lib/enum/seat-group-display-mode.enum';
import { SeatGroupSalesMode } from 'libs/core/src/lib/enum/seat-group-sales-mode.enum';
import { ISeatGroupModel } from 'libs/core/src/lib/interfaces';
import { AbstractViewModel } from '../../../abstract.view.model';
import { SeatGroupApiModel } from '../../../api-model/screen/seat/seat-group.api.model';

export class SeatGroupViewModel extends AbstractViewModel<SeatGroupApiModel> implements ISeatGroupModel {
  seatIds: string[];
  id: string;
  ico: string;
  color: string;
  name: string;
  description: string;
  type: string;
  displayMode: SeatGroupDisplayMode;
  salesMode: SeatGroupSalesMode;

  constructor(protected apiModel: SeatGroupApiModel = new SeatGroupApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.seatIds = this.apiModel.seatIds;
    this.id = this.apiModel.id;
    this.ico = this.apiModel.ico;
    this.color = this.apiModel.color;
    this.name = this.apiModel.name;
    this.description = this.apiModel.description;
    this.displayMode = this.apiModel.displayMode;
    this.salesMode = this.apiModel.salesMode;
  }

  toApiModel(): SeatGroupApiModel {
    return undefined;
  }

  toString() {
    return this.name;
  }
}
